interface CpmStatusChipProps {
    status?: string | null;
    className?: string;
}

const STATUS_STYLES: Record<string, string> = {
    ACTIVE: 'bg-[var(--cpm-success-bg)] text-[var(--cpm-success-text-light)] border-[var(--cpm-success-border)]',
    INACTIVE: 'bg-white text-[var(--cpm-text-secondary)] border-[var(--cpm-border-strong)]',
    PENDING: 'bg-[var(--cpm-info-bg)] text-[var(--cpm-info-text)] border-[var(--cpm-info-border)]',
    NEEDS_REVIEW:
        'bg-[var(--cpm-warning-bg)] text-[var(--cpm-warning-text)] border-[var(--cpm-warning-border)]',
    MERGED: 'bg-[var(--cpm-surface-skeleton)] text-[var(--cpm-text-secondary)] border-[var(--cpm-border-default)]',
    REJECTED:
        'bg-[var(--cpm-shortfall-bg)] text-[var(--cpm-shortfall-text)] border-[var(--cpm-shortfall-border)]',
    CONFLICTED:
        'bg-[var(--cpm-shortfall-bg)] text-[var(--cpm-shortfall-text)] border-[var(--cpm-shortfall-border)]',
};

export default function CpmStatusChip({ status, className = '' }: CpmStatusChipProps) {
    const normalized = String(status ?? '').trim();
    const style =
        STATUS_STYLES[normalized] ??
        'bg-[var(--cpm-surface-subtle)] text-[var(--cpm-text-secondary)] border-[var(--cpm-border-default)]';
    const label = normalized ? normalized.replaceAll('_', ' ') : '—';

    return (
        <span style={{ justifySelf: 'start', alignSelf: 'center', display: 'block' }}>
            <span
                className={[
                    'inline-flex items-center px-[9px] py-[3px] rounded-full border text-[10px] font-extrabold uppercase tracking-[0.04em]',
                    style,
                    className,
                ].join(' ')}
                style={{ width: 'max-content', maxWidth: 'max-content', whiteSpace: 'nowrap' }}
            >
                {label}
            </span>
        </span>
    );
}
